"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Help = Help;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const Footer_1 = require("../ui/Footer");
const TraitIcon_1 = require("../ui/TraitIcon");
const text_1 = require("../ui/text");
const ui_1 = require("@creature-chess/ui");
const useStyles = (0, react_jss_1.createUseStyles)({
    pieceType: {
        display: "inline-block",
        // todo consider use of px here
        width: "24px",
        height: "24px",
        marginRight: "0.5rem",
    },
    list: {
        "marginBottom": "1rem",
        "marginLeft": "1.5rem",
        "list-style-type": "disc",
        "& > li": {
            "fontSize": "12px",
            "marginBottom": "8px",
            "@media (min-width: 400px)": {
                fontSize: "16px",
                marginBottom: "12px",
            },
        },
    },
    help: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "0.25em",
        color: "#fff",
    },
    helpText: {
        "fontSize": "12px",
        "marginBottom": "8px",
        "@media (min-width: 400px)": {
            fontSize: "16px",
            marginBottom: "12px",
        },
    },
    header: {
        "display": "flex",
        "flexDirection": "row",
        "& h2": {
            flex: "1",
        },
    },
});
function Help({ hideFooter = false, onBack, }) {
    const styles = useStyles();
    return (React.createElement("div", { className: styles.help },
        React.createElement("div", null,
            React.createElement("div", { className: styles.header },
                React.createElement(text_1.Header2, null, "The Game"),
                onBack && (React.createElement(ui_1.Button, { color: "muted", size: "medium", onClick: onBack }, "Back"))),
            React.createElement("p", { className: styles.helpText }, "Buy pieces and place them on the board. Your board then battles another random player's board."),
            React.createElement("p", { className: styles.helpText }, "If you lose, your health will decrease. If your health hits 0, you will be knocked out."),
            React.createElement("p", { className: styles.helpText }, "The winner is the last player remaining!")),
        React.createElement("div", null,
            React.createElement(text_1.Header2, null, "Creatures"),
            React.createElement("p", { className: styles.helpText }, "Three creatures (level 1) will combine to make a stronger creature (level 2). Three level 2 creatures can then evolve into a level 3 creature."),
            React.createElement("p", { className: styles.helpText }, "Each creature has a class and a type. Their class determines their fighting style, and types give some boost/reduction to damage when fighting other types."),
            React.createElement(text_1.Header4, null, "Classes"),
            React.createElement("ul", { className: styles.list },
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "valiant" })),
                    "Valiant: All-round melee."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "cunning" })),
                    "Cunning: High damage, low-health melee."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "arcane" })),
                    "Arcane: Ranged.")),
            React.createElement(text_1.Header4, null, "Types"),
            React.createElement("ul", { className: styles.list },
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "earth" })),
                    "Earth: Beats water."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "metal" })),
                    "Metal: Beats wood."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "water" })),
                    "Water: Beats fire."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "wood" })),
                    "Wood: Beats earth."),
                React.createElement("li", null,
                    React.createElement("div", { className: styles.pieceType },
                        React.createElement(TraitIcon_1.TraitIcon, { trait: "fire" })),
                    "Fire: Beats metal."))),
        React.createElement("div", null,
            React.createElement(text_1.Header2, null, "Money"),
            React.createElement("p", { className: styles.helpText }, "After each round you will receive some money:"),
            React.createElement("ul", { className: styles.list },
                React.createElement("li", null, "Bonus for winning the round"),
                React.createElement("li", null, "10% interest"),
                React.createElement("li", null, "Win / loss streak bonus"))),
        !hideFooter && React.createElement(Footer_1.Footer, null)));
}
